import { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading';
import FidelityPopupExcelDownload from './FidelityPopupExcelDownload';
import PopupDataGrid from '../../../component/common/popup/PopupDataGrid';

import '../../../css/data-grid.css';

const FidelityMngPopup = () => {
    const [data, setData] = useState([]);

    const head = ['병원명', '환자등록번호', '내원날짜', '내원시간', '상태값'];
    const head_column = ['EMOGDESC', 'PTMIIDNO', 'PTMIINDT', 'PTMIINTM', 'PTMISTAT'];

    const isSearched = true;

    const sendData = JSON.parse(localStorage.getItem('sendData'));

    // 팝업은 열리자마자 조회를 시작하므로 로딩 상태로 시작 (첫 렌더에 버튼이 깜빡이지 않도록)
    const [loading, setLoading] = useState(true);

    let title_type = sendData.type;
    let title_name = sendData.clsdesc;

    const typeSuffixMap = {
        '01': ' 재검토',
        '02': ' 오류',
        '03': ' 재검토',
        '04': ' 재검토'
    };

    if (typeSuffixMap[title_type]) {
        title_name += typeSuffixMap[title_type];
    }

    const popupData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_mng_data_popup.do',
                { params: sendData }
            );
            setData(response.data.popupData);
            setLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setLoading(true);
        popupData();
    }, []);

    const flag = sendData.flag;

    return (
        <div className={`popup_container ${flag === 'ptmi' ? 'bg_st_bg' : flag === 'trms' ? 'bg_tr_bg' : ''}`}>
            <div className='flex justify-between'>
                <h4 className='sub_title w-70'>{title_name} 데이터 목록</h4>
                {loading || data.length === 0 ? '' :
                    <div className='btn_container mt-3'>
                        <FidelityPopupExcelDownload
                            data={data}
                            searched={isSearched}
                            menuName={'월별정보관리내역'}
                            ratioName={`${typeSuffixMap[title_type]}데이터목록`}
                            sendData={sendData}
                        />
                    </div>
                }
            </div>
            {loading ? <Loading /> :
                <PopupDataGrid
                    dataHead={head}
                    dataColumn={head_column}
                    dataList={data}
                    flag={flag} />
            }
        </div>
    )
}

export default FidelityMngPopup;